import { render, staticRenderFns } from "./MailSettingsEmailServer.vue?vue&type=template&id=624fe89d&scoped=true"
import script from "./MailSettingsEmailServer.vue?vue&type=script&lang=ts"
export * from "./MailSettingsEmailServer.vue?vue&type=script&lang=ts"
import style0 from "./MailSettingsEmailServer.vue?vue&type=style&index=0&id=624fe89d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624fe89d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624fe89d')) {
      api.createRecord('624fe89d', component.options)
    } else {
      api.reload('624fe89d', component.options)
    }
    module.hot.accept("./MailSettingsEmailServer.vue?vue&type=template&id=624fe89d&scoped=true", function () {
      api.rerender('624fe89d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/MailSettingsEmailServer.vue"
export default component.exports